export function isAttachFilesButtonDisabled(attachDisabled, completedPhase) {
  return attachDisabled === undefined || attachDisabled || completedPhase
}
